export const GET_LOCATION_AND_IP = "GET_LOCATION_AND_IP";
